import { TrlPillRejected } from './TrlPillRejected';

export { TrlPillRejected } from './TrlPillRejected';
export default TrlPillRejected;
